<template>
<main class="container-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <h2 class="doc-delete-title">{{ doc.filename }}</h2>
    </div>

    <div class="container-body">

        <span>¿Realmente deseas eliminar este documento?</span>
        <br>
        <span>Si lo haces, un registro de este recurso quedará en la base de datos</span>
        <br><br>
        <DocumentPreview
            v-if="doc.path"
            :url="contentUrl(doc)"
            :extension="fileExtension(doc)"
            :name="doc.filename"
            :size="doc.file_size"
            collapsible
        />
        <div v-else-if="doc.id" class="doc-preview__empty">
            Este documento no tiene archivo asociado.
        </div>

        <button class="btn btn-danger" style="margin-right: 1em;" :disabled="deleting" v-on:click="onClickDelete()">
            {{ deleting ? 'Eliminando...' : 'Sí' }}
        </button>
        <button class="btn btn-secondary" v-on:click="onClickDontDelete()">No</button>

        <div v-if="validationMessage" class="validation-summary">
            <div class="validation-summary__message">
                {{ validationMessage }}
            </div>
        </div>

    </div>

</main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'
import DocumentPreview from '@/components/DocumentPreview.vue'

import { restDocument } from '@/components/mixin/restDocument.js'

export default{
    name: 'DocumentsDelete',
    mixins: [restDocument],
    data(){
        return{
            validationMessage: '',
            deleting: false,
        }
    },
    components:{
        Breadcrumb,
        DocumentPreview,
    },
    computed: {
        routesBread: function(){
          return [
              {name:'Documentos', path: '/documentos' },
              {name: this.doc.filename, path: '/documentos/' + this.$route.params.idDoc},
              {name: 'Eliminar documento'}
              ]
        }
    },
    props: [],
    methods:{
        onClickDelete: function() {
            this.deleting = true
            //deleteDoc() navega a /documentos en el éxito; el finally sólo
            //importa en el error, que deja al usuario en esta misma vista.
            this.deleteDoc().finally(() => { this.deleting = false })
        },
        onClickDontDelete: function() {
            window.history.length > 1
                ? this.$router.go(-1)
                : this.$router.push('/documentos/' + this.$route.params.idDoc + '/editar-documento')
        },
    },
    created () {
        this.$store.getters.getPermissions?.documents ? true : this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getDoc();
    }
}
</script>

<style lang="scss" scoped>
/* Un nombre de documento largo sin espacios (hasta 150 caracteres, ver
   validateDocumentFields en el backend) no debe poder ensanchar el header
   de la página — mismo problema que ya se cubrió en Breadcrumb.vue y en
   la tabla de Documents.vue. */
.doc-delete-title {
  overflow-wrap: anywhere;
}

.doc-preview__empty {
	margin: 0.75rem 0;
	font-size: 0.85rem;
	color: var(--color-ghost);
}

.validation-summary {
	margin-top: 1rem;
	padding: 1rem;
	border: 1px solid #dc3545;
	border-radius: 4px;
	background-color: #fff5f5;
}
.validation-summary__message {
	color: #dc3545;
	font-weight: 600;
}
</style>
